import { DELIVERY_GUIDE } from '@/api/apiModules'

export default {
  viewType: 'table',
  module: DELIVERY_GUIDE,
  sortArr: [
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  refreshInterval: false,
  params: {},
  allowStatus: {},
  toolbar: {
    searchWidth: 300,
    searchPlaceholder: '文档名称',
    searchFieldNameArr: ['docName'],
    items: [
      {
        slot: 'refresh-rigtht',
        label: 'create',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'GuideCreate'
      }
    ]
  },
  class: 'sk-custom-table-right-page',
  view: {
    'cell-class-name': 'sk-customize-cell-hight',
    columns: [
      {
        props: {
          label: '指导配置名称',
          prop: 'docName',
          sortField: 'docName',
          width: 280
        }
      },
      {
        props: {
          label: '指导配置类型',
          prop: 'guideType',
          width: 200
        },
        filter: true,
        dataType: 'enum',
        dictionaryPath: 'guideType'
      },
      {
        props: {
          label: '指导配置子类型',
          prop: 'guideSubType',
          width: 200
        }
      },
      {
        props: {
          label: '指导链接地址',
          prop: 'guidePath'
        }
      },
      {
        props: {
          label: '指导说明',
          prop: 'guideDesc'
        }
      },
      {
        props: {
          label: '适用产品',
          prop: 'productNameSupport',
          width: 220
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime',
          width: 160
        },
        dataType: 'date'
      },
      {
        props: {
          label: '更新时间',
          prop: 'updateTime',
          sortField: 'updateTime',
          width: 160
        },
        dataType: 'date'
      },
      {
        //操作
        props: {
          showBtnNum: '3',
          fixed: null
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: '编辑',
        command: 'GuideEdit',
        name: 'GuideEdit'
      },
      {
        icon: 'el-icon-delete',
        label: 'delete',
        command: 'GuideDelete',
        name: 'delete',
        confirm: {
          msg: 'tips.confirm.deliveryGuideMng.deleteMsg'
        }
      }
    ]
  }
}
